import useAuth from '@src/core/auth/components/auth0-wrapper';
import AuthErrorComponent from '@src/core/routing/components/auth/auth-error.component';

const AuthErrorCheckerProvider = ({ children = null }) => {
  const { error } = useAuth();
  if (error) {
    return <AuthErrorComponent />;
  }
  return children;
};

export default AuthErrorCheckerProvider;
